"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.goToSummary = goToSummary;
exports.setCurrentStep = setCurrentStep;
exports.setCustomerName = setCustomerName;
exports.setCustomerSurname = setCustomerSurname;
exports.setCustomerType = setCustomerType;
exports.setExistingCustomer = setExistingCustomer;
exports.setFrequency = setFrequency;
exports.setPackage = setPackage;
exports.setTermsAndConditions = setTermsAndConditions;
exports.stepBack = stepBack;
function setCurrentStep(step) {
  return {
    type: 'setCurrentStep',
    step
  };
}
function setPackage(packageItem) {
  return {
    type: 'setPackage',
    packageItem
  };
}
function setCustomerType(customerType) {
  return {
    type: 'setCustomerType',
    customerType
  };
}
function setExistingCustomer(existingCustomer) {
  return {
    type: 'setExistingCustomer',
    existingCustomer
  };
}
function setFrequency(item) {
  return {
    type: 'setFrequency',
    item
  };
}
function setCustomerName({
  currentTarget: {
    value: firstName
  }
}) {
  return {
    type: 'setCustomerName',
    firstName
  };
}
function setCustomerSurname({
  currentTarget: {
    value: surname
  }
}) {
  return {
    type: 'setCustomerSurname',
    surname
  };
}
function goToSummary() {
  return {
    type: 'goToSummary'
  };
}
function stepBack() {
  return {
    type: 'stepBack'
  };
}
function setTermsAndConditions({
  currentTarget: {
    checked: termsAndConditionsAccepted
  }
}) {
  return {
    type: 'setTermsAndConditions',
    termsAndConditionsAccepted
  };
}
